import { deepCopy } from '../utils';

/**
 * Offline operation config for reportIncorrectStockSetting.
 *
 * Drivers can report a wrong par level or capacity while offline. The report is
 * queued and replayed when connectivity returns, and the server deduplicates it
 * by docket, selection and setting, so a replay never notifies the manager twice.
 */
const reportIncorrectStockSettingConfig = {
	serializeVariables: ({ variables }) => deepCopy(variables),
	createMeta: ({ variables, context = {} }) => {
		const offlineMeta = context.offlineMeta || {};

		return {
			serviceDocketId: variables?.serviceDocketId,
			planogramItemId: variables?.planogramItemId,
			setting: variables?.setting,
			type: 'reportIncorrectStockSetting',
			machine: offlineMeta.machineDetails || null,
			machineId: offlineMeta.machineId || null,
			fallbackMachineName: offlineMeta.machineName || null,
		};
	},
	getOfflineResult: ({ variables, queueEntry }) => ({
		reportIncorrectStockSetting: {
			__typename: 'ReportIncorrectStockSettingResult',
			serviceDocketId: variables?.serviceDocketId,
			planogramItemId: variables?.planogramItemId,
			setting: variables?.setting,
			reported: true,
			offline: true,
			offlineQueuedAt: queueEntry.createdAt,
		},
	}),
};

export default reportIncorrectStockSettingConfig;
